import { render, staticRenderFns } from "./ToolbarNav.vue?vue&type=template&id=4489f9c4&"
import script from "./ToolbarNav.vue?vue&type=script&lang=js&"
export * from "./ToolbarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports